<template>
  <!--SKU查询弹出窗-->
  <a-modal
      title="SKU"
      :visible="querySkuWindow"
      width="80%"
      :maskClosable="false"
      :footer="null"
      :zIndex="99"
      @cancel="cancelQuerySearch">
    <a-row>
      <a-row type="flex" justify="space-between">
        <a-col>
          <a-row type="flex" justify="start">
            <a-col >
              <a-input size="small" style="width: 150px" v-model="querySkuCode" @pressEnter="initSku"/>
            </a-col>
            <img class="funcButton" src="../../../assets/img/search.png" width="22" height="22" @click="initSku" :title="$t('batchReceive.Query')">
            <img class="funcButton" src="../../../assets/img/refresh2.png" width="22" height="22" @click="resetSku" :title="$t('generic.Refresh')">
          </a-row>
        </a-col>
        <a-col>
          <div style="display: flex; align-items: center; gap: 8px; margin-right: 12px;">
            <a-button
                type="primary"
                size="small"
                :disabled="!hasPrev"
                @click="prevPage"
                style="font-size: 16px; height: 32px; padding: 0 15px;">
              {{ $t('publicLang.PreviousPage') }}
            </a-button>
            <span style="font-size: 12px; color: #666;">{{ $t('publicLang.Page') }} {{ currentSkuVal }}</span>
            <a-button
                type="primary"
                size="small"
                :disabled="!hasNext"
                @click="nextPage"
                style="font-size: 16px; height: 32px; padding: 0 15px;">
              {{ $t('publicLang.NextPage') }}
            </a-button>
          </div>
        </a-col>
      </a-row>
      <a-row style="height: 65vh;" class="mt">
        <vxe-table
            stripe
            resizable
            border
            highlight-hover-column
            highlight-hover-row
            highlightCurrentRow
            show-header-overflow
            show-overflow
            :sort-config="{multiple: true, trigger: 'cell'}"
            @cell-dblclick="checkedSku"
            align="center"
            height="auto"
            size="mini"
            :data="PagingGridSkuList">
          <template v-slot:empty>
            <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
          </template>
          <vxe-table-column field="sku" :title="$t('skuSearch.skuCode')" width="200" sortable></vxe-table-column>
          <vxe-table-column field="skuDesc" :title="$t('skuSearch.skuDesc')" width="200" sortable></vxe-table-column>
          <vxe-table-column field="upc" :title="$t('skuSearch.upc')" width="200" sortable></vxe-table-column>
          <vxe-table-column field="style" :title="$t('skuSearch.style')" width="200" sortable></vxe-table-column>
          <vxe-table-column field="color" :title="$t('skuSearch.color')" width="200" sortable></vxe-table-column>
          <vxe-table-column field="size"  :title="$t('skuSearch.size')" width="200" sortable></vxe-table-column>
          <vxe-table-column field="creator" :title="$t('generic.Creator')" width="200" sortable></vxe-table-column>
          <vxe-table-column field="createTime" :title="$t('generic.CreateTime')" width="200" :formatter="formatTime" sortable></vxe-table-column>
          <vxe-table-column field="modifier" :title="$t('generic.Modifier')" width="200" sortable></vxe-table-column>
          <vxe-table-column field="modifyTime" :title="$t('generic.ModifyDate')" width="200" :formatter="formatTime" sortable></vxe-table-column>
        </vxe-table>
      </a-row>
    </a-row>
  </a-modal>
</template>

<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import XEUtils from "xe-utils";

export default{
  data(){
    return{
      fieldName: '',
      querySkuWindow: false,
      pagingSkuSize: 30,
      currentSkuVal: 1,
      PagingGridSkuList: [],
      querySkuCode: '',
      hasNext: false,
      hasPrev: false,
    }
  },
  methods:{
    show(fieldName, data) {
      this.fieldName = fieldName
      this.querySkuWindow = true
      this.querySkuCode = data
      this.initSku()
    },
    prevPage() {
      if (this.hasPrev) {
        this.currentSkuVal--;
        this.querySku();
      }
    },
    nextPage() {
      if (this.hasNext) {
        this.currentSkuVal++;
        this.querySku();
      }
    },
    cancelQuerySearch() {
      this.querySkuWindow = false
    },
    initSku() {
      this.currentSkuVal = 1;
      this.querySku();
    },
    querySku() {
      let params = {
        currentVal: this.currentSkuVal,
        pagingSize: this.pagingSkuSize,
        skuCode: this.querySkuCode
      }
      ajax.get(api.SEARCHSKU, params).then(res => {
        if (res.code == 200) {
          this.PagingGridSkuList = res.data;
          this.hasNext = res.hasNext;
          this.hasPrev = res.hasPrev;
          if (this.PagingGridSkuList.length == 1) {
            this.selectedSku(this.PagingGridSkuList[0].sku);
          }
        }
      })
    },
    resetSku() {
      this.querySkuCode = "";
      this.pagingSkuSize = 30;
      this.currentSkuVal = 1;
      this.querySku();
    },
    formatTime({cellValue}) {
      return XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:ss:mm')
    },
    checkedSku({row}) {
      this.selectedSku(row.sku);
    },
    selectedSku(sku) {
      this.querySkuWindow = false;
      this.$emit("checkedSkuCode", this.fieldName, sku);
    },
  }
}
</script>

<style scoped>
.funcButton {
  cursor: pointer;
  margin-left: 5px;
}
</style>
